module.exports = __webpack_public_path__ + "img/SideView_ExtremeLight.5110d9b1.png";